import {SummaryModel} from "../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../common/entity/permissions.model";
import {PartnerSummaryModel} from "../../../../partner/common/api/model/partnerSummary.model";


export class PriceListSummaryModel implements SummaryModel{
    id: number;
    permissions: PermissionsModel;
    name: string;
    partner: PartnerSummaryModel;
}